import { URL } from "../../api/Api";
import { LAYOUT } from "../Action";
import { catchError, GET, POST, PUT } from "../axios/Axios";

export const LoginCall = async (payload) => {
  try {
    const response = await fetch(`${URL}/token/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorResponse = await response.text();
      let errorMessage = "An error occurred";
      try {
        const parsedError = JSON.parse(errorResponse);
        errorMessage = parsedError.message || errorMessage;
      } catch (parseError) {}
      throw new Error(errorMessage);
    }

    return response.json();
  } catch (error) {
    throw catchError(error);
  }
};

//Forgot-password
export const ForgotPasswordCall = async (payload, params) => {
  try {
    const response = await POST(`${URL}/customers/password/`, payload, params);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

//Reset-password
export const ResetPasswordCall = async (id, payload) => {
  try {
    const response = await PUT(`${URL}/customers/password/${id}`, payload, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const MinimizeIcon = (layoutLeft, jobRight) => {
  return {
    type: LAYOUT.minimizeIcon,
    layoutLeft: layoutLeft,
    jobRight: jobRight,
  };
};

export const PreviousPathName = (data) => {
  return {
    type: LAYOUT.pathName,
    data: data,
  };
};

//sign-up

export const SignUpCall = (payload) => {
  return async (dispatch) => {
    try {
      const response = await POST(
        `${URL}/customers/organization/create`,
        payload,
        {}
      );
      dispatch({ type: LAYOUT.signUp, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

//plan-expired
export const PlanExpiredCall = async (id) => {
  try {
    const response = await GET(
      `${URL}/customers/organization/subscription/check/${id}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const SetLocalStorage = (data) => {
  return {
    type: LAYOUT.localStorage,
    data: data,
  };
};
